import loaded from '@/scripts/helpers/loaded';

loaded(() =>{
    const activeItem = document.querySelector('.item--product__tabs.active--item');

    if (activeItem) {
        const id = activeItem.getAttribute('data-id');

        document.querySelectorAll('.tab__section--' + id).forEach((content) => {
            if (!content) {
                return;
            }

            content.style.display = 'block';
        });

    }

    const resourcesContent = document.getElementById('resources_content');
    if (!resourcesContent) {
        document.querySelectorAll('.item--product__tabs[data-id="resources_content"]').forEach((resourcesTab) => {
            if (!resourcesTab) {
                return;
            }

            resourcesTab.style.display = 'none';
        });
    }

    document.querySelectorAll('.js--tabs__items').forEach(function (select) {
        select.addEventListener('change', function () {
            const val = this.value;
            const option = this.options[this.selectedIndex];
            const hasReview = option.getAttribute('data-review');
            const parent = document.querySelector('.item--product__tabs[data-id="' + val + '"]');
            const hasClass = parent?.classList.contains('active');

            const tabLink = document.querySelector('.item--product__tabs[data-id="' + val + '"] a.js--tab__product');
            if (tabLink) tabLink.click();

            if (!hasClass) {
                document.querySelectorAll('.item--product__tabs').forEach(tab =>
                    tab.classList.remove('active--item')
                );
                document.querySelectorAll('.js--secction__tab').forEach(section =>
                    section.style.display = 'none'
                );

                document.querySelectorAll('.tab__section--' + val).forEach((content) => {
                    if (content) content.style.display = 'block';
                })

                if (parent) parent.classList.add('active--item');

                if (hasReview === 'true') {
                    const reviewsSection = document.getElementById('reviews_section');
                    if (reviewsSection) {
                        const targetPosition = reviewsSection.offsetTop - 110;
                        window.scrollTo({
                            top: targetPosition,
                            behavior: 'smooth'
                        });
                    }
                }
            }
        });
    });

    document.querySelectorAll('.js--tab__product').forEach(function (tabLink) {
        tabLink.addEventListener('click', function (e) {
            e.preventDefault();
            const hasReview = this.classList.contains('reviews--section-js');
            const parent = this.closest('.item--product__tabs');
            const id = parent?.getAttribute('data-id');
            const hasClass = parent?.classList.contains('active--item');
            const contentSections = Array.from(document.querySelectorAll('.tab__section--' + id));

            if (!hasClass) {
                document.querySelectorAll('.item--product__tabs').forEach(tab =>
                    tab.classList.remove('active--item')
                );
                document.querySelectorAll('.js--secction__tab').forEach(section =>
                    section.style.display = 'none'
                );

                if (contentSections) contentSections?.forEach(content => {
                    content.style.display = 'block'
                });
                
                if (parent) parent.classList.add('active--item');

                if (hasReview) {
                    const reviewsSection = document.getElementById('reviews_section');
                    if (reviewsSection) {
                        const targetPosition = reviewsSection.offsetTop - 110;
                        window.scrollTo({
                            top: targetPosition,
                            behavior: 'smooth'
                        });
                    }
                }
            }
        });
    });
});
